(() => {
  'use strict';

  const root =
    document.querySelector(
      '[data-pn-compare-preview-live]'
    );

  if (!root) return;


  const selectA =
    root.querySelector(
      '[data-pncp-select-a]'
    );

  const selectB =
    root.querySelector(
      '[data-pncp-select-b]'
    );

  const compareButton =
    root.querySelector(
      '[data-pncp-compare]'
    );

  const swapButton =
    root.querySelector(
      '[data-pncp-swap]'
    );

  const labelA =
    root.querySelector(
      '[data-pncp-label-a]'
    );

  const labelB =
    root.querySelector(
      '[data-pncp-label-b]'
    );

  const metaA =
    root.querySelector(
      '[data-pncp-meta-a]'
    );

  const metaB =
    root.querySelector(
      '[data-pncp-meta-b]'
    );


  if (
    !selectA ||
    !selectB ||
    !compareButton
  ) {
    return;
  }


  let colleges = [];
  let collegeMap =
    new Map();


  function locationText(
    college
  ) {

    return [
      college?.city,
      college?.state
    ]
      .filter(Boolean)
      .join(', ');

  }


  function buildOption(
    college
  ) {

    const option =
      document.createElement(
        'option'
      );

    option.value =
      college.id;

    option.textContent =
      college.name;

    return option;

  }


  function populate() {

    selectA.innerHTML =
      '<option value="">Choose first college</option>';

    selectB.innerHTML =
      '<option value="">Choose second college</option>';


    colleges.forEach(
      college => {

        selectA.appendChild(
          buildOption(college)
        );

        selectB.appendChild(
          buildOption(college)
        );

      }
    );


    sync();

  }


  function selectedCollege(
    select
  ) {

    return collegeMap.get(
      select.value
    );

  }


  function updateVisual(
    select,
    label,
    meta,
    fallbackLabel
  ) {

    const college =
      selectedCollege(select);


    if (!college) {

      label.textContent =
        fallbackLabel;

      meta.textContent =
        'Select from PeerNest colleges';

      return;

    }


    label.textContent =
      college.name;


    meta.textContent =
      locationText(college) ||
      'PeerNest college';

  }


  function syncDisabledOptions() {

    const a =
      selectA.value;

    const b =
      selectB.value;


    [...selectA.options]
      .forEach(
        option => {

          if (!option.value) return;

          option.disabled =
            option.value === b;

        }
      );


    [...selectB.options]
      .forEach(
        option => {

          if (!option.value) return;

          option.disabled =
            option.value === a;

        }
      );

  }


  function sync() {

    updateVisual(
      selectA,
      labelA,
      metaA,
      'Choose first college'
    );


    updateVisual(
      selectB,
      labelB,
      metaB,
      'Choose second college'
    );


    syncDisabledOptions();


    const valid =
      Boolean(
        selectA.value &&
        selectB.value &&
        selectA.value !==
          selectB.value
      );


    compareButton.disabled =
      !valid;

    root.classList.toggle(
      'is-ready-to-compare',
      valid
    );

  }


  selectA.addEventListener(
    'change',
    sync
  );


  selectB.addEventListener(
    'change',
    sync
  );


  swapButton
    ?.addEventListener(
      'click',
      () => {

        const oldA =
          selectA.value;

        selectA.value =
          selectB.value;

        selectB.value =
          oldA;

        sync();

      }
    );


  compareButton
    .addEventListener(
      'click',
      () => {

        const collegeA =
          selectA.value;

        const collegeB =
          selectB.value;


        if (
          !collegeA ||
          !collegeB ||
          collegeA === collegeB
        ) {
          return;
        }


        const params =
          new URLSearchParams();

        params.set(
          'college',
          collegeA
        );

        params.set(
          'college2',
          collegeB
        );

        params.set(
          'autocompare',
          '1'
        );


        window.location.href =
          '/pages/compare?' +
          params.toString();

      }
    );


  function waitForDB(
    attempt = 0
  ) {

    if (window.PeerNestDB) {

      load();

      return;

    }


    if (attempt >= 60) {

      console.error(
        '[PeerNest Compare Preview] PeerNestDB unavailable.'
      );

      return;

    }


    setTimeout(
      () =>
        waitForDB(
          attempt + 1
        ),
      100
    );

  }


  async function load() {

    try {

      colleges =
        await window.PeerNestDB
          .getPublishedColleges();


      colleges =
        Array.isArray(colleges)
          ? colleges
          : [];


      collegeMap =
        new Map(
          colleges.map(
            college => [
              String(college.id),
              college
            ]
          )
        );


      populate();


      console.log(
        `[PeerNest Compare Preview] ${colleges.length} colleges loaded.`
      );

    }

    catch (error) {

      console.error(
        '[PeerNest Compare Preview] Failed:',
        error
      );


      compareButton.disabled =
        true;

    }

  }


  waitForDB();

})();
